import React from 'react';
import Login from './Login';

/**
 * The login route.
 *
 * This used to draw a bordered card with a "Login" heading and put the form
 * inside it, which meant the screen said Login twice. The screen now owns its
 * own layout, so this is only the seam App.js renders through — kept as a
 * module because App.js imports it by this name.
 */
export default function SignupAndLogin(props) {
  return <Login showHandler={props.showHandler} />;
}
